const CLOSE_LOGIN_BLOCK = 'efes/loginBlock/CLOSE_LOGIN_BLOCK';
const SHOW_LOGIN = 'efes/loginBlock/SHOW_LOGIN';

const SHOW_RECOVER_PASS = 'efes/loginBlock/SHOW_RECOVER_PASS';
const HIDE_RECOVER_PASS = 'efes/loginBlock/HIDE_RECOVER_PASS';

const SHOW_FORGOT_PASS = 'efes/loginBlock/SHOW_FORGOT_PASS';
const HIDE_FORGOT_PASS = 'efes/loginBlock/HIDE_FORGOT_PASS';

const initialState = {
  isOpen: false,
  showRecoverPassword: false,
  showForgotPassword: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case CLOSE_LOGIN_BLOCK:
      return {
        ...state,
        isOpen: false,
      };
    case SHOW_LOGIN:
      return {
        isOpen: true,
        showRecoverPassword: false,
        showForgotPassword: false,
      };
    case SHOW_RECOVER_PASS:
      return {
        showRecoverPassword: true,
        showForgotPassword: false,
        isOpen: false,
      };
    case HIDE_RECOVER_PASS:
      return {
        ...state,
        showRecoverPassword: false,
      };
    case SHOW_FORGOT_PASS:
      return {
        showForgotPassword: true,
        showRecoverPassword: false,
        isOpen: false,
      };
    case HIDE_FORGOT_PASS:
      return {
        ...state,
        showForgotPassword: false,
      };
    default:
      return state;
  }
}

export const closeLoginBlock = () => ({
  type: CLOSE_LOGIN_BLOCK,
});

export const showLogin = () => ({
  type: SHOW_LOGIN,
});

export const showRecoverPass = () => ({
  type: SHOW_RECOVER_PASS,
});

export const hideRecoverPass = () => ({
  type: HIDE_RECOVER_PASS,
});

export const showForgotPass = () => ({
  type: SHOW_FORGOT_PASS,
});

export const hideForgotPass = () => ({
  type: HIDE_FORGOT_PASS,
});
